import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function PersonnelBankAccountInfoForm({ 
  handleChange,
  values
 }) {
  return (
    <>
      <Form.Group as={Row} controlId="contract.bank">
        <Form.Label column sm={2}>
          Banka
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.bank} placeholder="Banka" onChange={handleChange} />
        </Col>
      </Form.Group>
                      
      <Form.Group as={Row} controlId="contract.accountNo">
        <Form.Label column sm={2}>
          Hesap No
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.accountNo} placeholder="Hesap No" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="contract.iban">
        <Form.Label column sm={2}>
          Iban
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.iban} placeholder="Iban" onChange={handleChange} />
        </Col>
      </Form.Group>
    </>        
  );
}